// function setCurrencyClassOnBody(currency) {
//   // Remove old currency classes
//   document.body.classList.forEach(cls => {
//     if (cls.startsWith('currency-')) {
//       document.body.classList.remove(cls);
//     }
//   });

//   // Add new currency class
//   document.body.classList.add('currency-' + currency);
// }

// // Detect click on currency items
// document.body.addEventListener('click', function (e) {
//   const item = e.target.closest('.currency-converter-chooser-item');
  
//   if (item) {
//     const match = item.className.match(/cbb-currency-code-([A-Z]{3})/);
    
//     if (match) {
//       const currency = match[1];

//       // Delay (important because converter updates after click)
//       setTimeout(() => {
//         setCurrencyClassOnBody(currency);
//       }, 200);
//     }
//   }
// });


document.addEventListener("click", function(e) {
  const btn = e.target.closest(".klaviyo-close-form, .needsclick.go2064679328");

  if (btn) {
    const popup = btn.closest('[role="dialog"]'); // correct parent

    if (popup) {
      popup.classList.add("active");
    }
  }
});













